import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import Anchor from '../../../commonComponents/Anchor';

function ShopProductPlaceholder({ t }) {
  return (
    <div className="highlighted-product compact" style={{ height: '14rem' }}>
      <div>
        <div className="highlighted-product-info">
          <div
            className="highlighted-product-text"
            style={{ marginRight: '15px' }}
          >
            <Anchor
              className="highlighted-product-title"
              style={{ fontSize: '1.5rem' }}
            >
              <div>{t('shop.no_products_title')}</div>
            </Anchor>
            <span
              className="highlighted-product-modules"
              style={{ fontSize: '1.1rem' }}
            >
              <span>
                {t('shop.no_products_description')}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

ShopProductPlaceholder.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(ShopProductPlaceholder);
